module.exports = __webpack_public_path__ + "static/media/arrow-to-bottom.19cf32c1.svg";